import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../stores/useAuthStore';
import { useModalStore } from '../../stores/useUIStore';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { validatePassword } from '../../utils/validation'; // 🟢 Importamos validador

const RegisterModal = () => {
  const closeModal = useModalStore((state) => state.closeModal);
  const modals = useModalStore((state) => state.modals);
  const login = useAuthStore((state) => state.login);
  const register = useAuthStore((state) => state.register);

  const [activeTab, setActiveTab] = useState('login');
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // States for login form
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');

  // States for register form
  const [regUsername, setRegUsername] = useState('');
  const [regEmail, setRegEmail] = useState('');
  const [regPassword, setRegPassword] = useState('');

  // Escuchamos ambos modales para unificar la experiencia
  const isLoginOpen = modals?.['loginModal']?.isOpen;
  const isRegisterOpen = modals?.['registerModal']?.isOpen;
  const isOpen = isLoginOpen || isRegisterOpen;

  useEffect(() => {
    // Sincronizar pestaña según qué modal se llamó
    if (isLoginOpen) setActiveTab('login');
    if (isRegisterOpen) setActiveTab('register');

    if (isOpen) {
      // Delay visibility for entry animation
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  }, [isOpen, isLoginOpen, isRegisterOpen]);

  const handleClose = () => {
    setIsVisible(false);
    // Delay closing for exit animation
    setTimeout(() => {
      closeModal('loginModal');
      closeModal('registerModal');
    }, 300);
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const result = await login({ email: loginEmail, password: loginPassword });

    if (result.success) {
      closeModal('loginModal');
      closeModal('registerModal');

      // 🟢 CORRECCIÓN DEFINITIVA DE REDIRECCIÓN
      const currentUser = useAuthStore.getState().currentUser;

      // Usamos una validación más inteligente que incluya a todos los rangos de admin
      const isAdmin = currentUser?.roles?.some(r => r.includes('admin')) || 
                      currentUser?.role?.includes('admin') ||
                      currentUser?.role === 'technician';

      if (isAdmin) {
        navigate('/admin/dashboard');
      } else {
        navigate('/');
      }
    }
    setIsSubmitting(false);
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    
    // 🟢 Validación de Seguridad de Contraseña
    const passwordError = validatePassword(regPassword);
    if (passwordError) {
      toast.error(passwordError);
      return;
    }

    setIsSubmitting(true);
    const success = await register({ username: regUsername, email: regEmail, password: regPassword });
    if (success) {
        toast.success('¡Registro exitoso! Por favor, inicia sesión.');
        setActiveTab('login');
        }
        setIsSubmitting(false);
    };

    if (!isOpen) {
        return null;
    }

  return (
    <div className={`fixed inset-0 z-[10000] flex items-center justify-center p-4 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="absolute inset-0 bg-black/60" onClick={handleClose}></div>
      <div className={`relative w-full max-w-md transform transition-all duration-300 ${isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <div className="relative rounded-2xl border border-white/20 bg-gray-900 p-8 shadow-[0_8px_32px_0_rgba(31,38,135,0.37)] backdrop-blur-xl">
          <button onClick={handleClose} className="absolute top-4 right-4 text-white/70 hover:text-white">
            <i className="fal fa-times text-2xl"></i>
          </button>

          <div className="flex mb-6 border-b border-white/20">
            <button
              onClick={() => setActiveTab('login')}
              className={`py-2 px-4 font-semibold transition-colors ${activeTab === 'login' ? 'border-b-2 border-[#D4AF37] text-[#D4AF37]' : 'text-white/60 hover:text-white'}`}
            >
              <i className="fal fa-sign-in-alt mr-2"></i> Login
            </button>
            <button
              onClick={() => setActiveTab('register')}
              className={`py-2 px-4 font-semibold transition-colors ${activeTab === 'register' ? 'border-b-2 border-[#D4AF37] text-[#D4AF37]' : 'text-white/60 hover:text-white'}`}
            >
              <i className="fal fa-user-plus mr-2"></i> Registro
            </button>
          </div>

          {activeTab === 'login' && (
            <form onSubmit={handleLoginSubmit} className="space-y-4 text-white">
              <div>
                <label className="block text-sm font-medium text-white/80">Correo Electrónico</label>
                <input type="email" value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} required className="mt-1 w-full bg-white/10 border border-white/20 rounded-md py-2 px-3 focus:ring-[#D4AF37] focus:border-[#D4AF37]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-white/80">Contraseña</label>
                <input type="password" value={loginPassword} onChange={(e) => setLoginPassword(e.target.value)} required className="mt-1 w-full bg-white/10 border border-white/20 rounded-md py-2 px-3 focus:ring-[#D4AF37] focus:border-[#D4AF37]" />
              </div>
              <button type="submit" className="w-full py-2 bg-[#D4AF37] text-black font-semibold rounded-md hover:bg-[#B5952F] disabled:bg-gray-600 transition-colors shadow-[0_0_15px_rgba(212,175,55,0.3)]" disabled={isSubmitting}>
                {isSubmitting ? 'Iniciando...' : 'Log In'}
              </button>
              <div className="text-center mt-4 space-x-4">
                <Link to="/forgot-password" onClick={handleClose} className="text-sm text-white/70 hover:text-white transition-colors">¿Olvidaste tu contraseña?</Link>
                <Link to="/auth" onClick={handleClose} className="text-sm text-white/70 hover:text-white transition-colors">Página completa</Link>
              </div>
            </form>
          )}

          {activeTab === 'register' && (
            <form onSubmit={handleRegisterSubmit} className="space-y-4 text-white">
              <div>
                <label className="block text-sm font-medium text-white/80">Nombre Completo</label>
                <input type="text" value={regUsername} onChange={(e) => setRegUsername(e.target.value)} required className="mt-1 w-full bg-white/10 border border-white/20 rounded-md py-2 px-3 focus:ring-[#D4AF37] focus:border-[#D4AF37]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-white/80">Correo Electrónico</label>
                <input type="email" value={regEmail} onChange={(e) => setRegEmail(e.target.value)} required className="mt-1 w-full bg-white/10 border border-white/20 rounded-md py-2 px-3 focus:ring-[#D4AF37] focus:border-[#D4AF37]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-white/80">Contraseña</label>
                <input type="password" value={regPassword} onChange={(e) => setRegPassword(e.target.value)} required className="mt-1 w-full bg-white/10 border border-white/20 rounded-md py-2 px-3 focus:ring-[#D4AF37] focus:border-[#D4AF37]" />
              </div>
              <button type="submit" className="w-full py-2 bg-[#D4AF37] text-black font-semibold rounded-md hover:bg-[#B5952F] disabled:bg-gray-600 transition-colors shadow-[0_0_15px_rgba(212,175,55,0.3)]" disabled={isSubmitting}>
                {isSubmitting ? 'Registrando...' : 'Register'}
              </button>
              <div className="text-center mt-4">
                <Link to="/auth" onClick={handleClose} className="text-sm text-white/70 hover:text-white transition-colors">¿Tienes problemas? Ir a la página completa</Link>
              </div>
            </form>
          )}

          <div className="log-separator fl-wrap my-6"><span className="text-white/50">o</span></div>
          <div className="soc-log fl-wrap text-center">
            <p className="text-white/80 mb-4">Para un acceso más rápido, usa tu cuenta social.</p>
            <button className="w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700">
              <i className="fab fa-facebook-f mr-2"></i>Conectar con Facebook
            </button>
                  </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;